<template>
  <div class="liuyan_main">
    <!-- 留言板内容区域 -->
    <div
      class="liuyan_list mar"
      v-for="(item, index) in booklist.list"
      :key="index"
    >
      <!-- 头部 -->
      <div class="header">
        <div class="img_header">
          <div class="img">
            <img :src="item.avatar" alt />
          </div>
          <div class="infomation">
            <p>
              {{ item.user_nicename }}
              <el-tag
                type="success"
                effect="dark"
                size="mini"
                v-for="(item1, index) in userType"
                :key="index"
                v-show="item1.id == item.user_type"
                >{{ item1.identity }}</el-tag
              >
            </p>
            <span>第 {{ booklist.listsum - index }} 楼</span>
          </div>
        </div>
        <!-- 更多 -->
        <el-dropdown size="mini">
          <i class="iconfont iconmore more"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="iconfont iconjubao" @click.native="jubao"
              >举报</el-dropdown-item
            >
            <el-dropdown-item
              class="iconfont iconshanchu-copy1"
              @click.native="shanchu(item)"
              >删除</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- 内容区域 -->
      <div class="main_are">
        <!-- 文本图片区 -->
        <div class="txt">
          <p>{{ item.gsb_content }}</p>
          <!-- <img :src="item.avatar" alt /> -->
          <p>
            <span>{{ item.create_time }}</span>
            <!-- <span>13:23</span> -->
            <!-- <span>留言</span>
            <span>回复</span> -->
          </p>
        </div>
        <!-- 评论区域 -->
        <!-- <div class="pinglun">
          <input type="text" v-model="pinglunmsg" placeholder="说点什么吧..." @click="pinglun" />
        </div> -->

        <!-- 删除弹框 -->
        <delete v-show="ashow"></delete>
        <!-- 举报提示 -->
        <inform v-show="bshow"></inform>
      </div>
    </div>
  </div>
</template>
<script>
import VueEvent from "../../api/eventBus";
import URL from "../../api/index";
import Delete from "../../components/space/delete";
import Inform from "../../components/space/inform";
import axios from "axios";
export default {
  components: {
    Delete,
    Inform,
  },
  props: ["booklist"],
  data() {
    return {
      //   评论的类容
      pinglunmsg: "",
      booklist_r: [],
      text: "",
      ashow: false,
      bshow: false,
      num: "",
      UserInfo: "",
      getSpaceinfo: "",
      pagenum: "10",
      userType: [
        { id: "2", identity: "学员" },
        { id: "3", identity: "教师" },
        { id: "4", identity: "校长" },
        { id: "5", identity: "学生" },
        { id: "6", identity: "教育局" },
      ],
    };
  },
  mounted() {
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    window.addEventListener("scroll", this.scrollEvent, false);
  },
  methods: {
    scrollEvent() {
      if (
        document.documentElement.scrollTop +
          document.documentElement.clientHeight >=
        document.body.scrollHeight
      ) {
        this.pagenum = Number(this.pagenum) + 30;
        this.$emit("shuaxin", this.pagenum);
      }
    },
    shanchu(e) {
      this.ashow = true;
      var that = this;
      VueEvent.$emit("num", "1");
      VueEvent.$off("tab");
      VueEvent.$on("tab", function (data) {
        var getspace_data = {
          token: that.UserInfo.token,
          gsbid: e.gsb_id,
        };
        //  删除留言
        this.$post(URL.delguestbook, getspace_data).then((res) => {
          that.getRjwDel(
            JSON.parse(localStorage.getItem("loginInfo")),
            e.gsb_id
          );
        });
      });
    },
    jubao() {
      VueEvent.$emit("val", "3");
      this.bshow = true;
      VueEvent.$emit("bao", "1");
    },
    //数据上报
    getRjwDel(hh, row) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        // 进入空间
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "studyspace_delete",
          user_id: String(hh.user_id),
          user_role: String(hh.user_type),
          user_name: String(hh.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: JSON.parse(localStorage.getItem("data_traceid")),
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.user_nicename}` + "使用了网络学习空间的删除功能",
          data: {
            function: '留言板',
            school_name: hh.teacher_info.school_name
              ? `${hh.teacher_info.school_name}`
              : "",
            school_id: hh.teacher_info.school_id
              ? `${hh.teacher_info.school_id}`
              : "",
            trace_id: JSON.parse(localStorage.getItem("space_traceid")),
            delete_id: row,
          },
        };
        axios
          .post("http://47.114.114.56:9002/RecordRjw", saydata)
          .then((res) => {
            this.$emit("shuaxin", this.pagenum);
          });
      });
    },
   
  },
};
</script>
<style lang="less">
.liuyan_list {
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(15, 26, 47, 0.06);
  border-radius: 4px;
  box-sizing: border-box;
  padding: 25px 25px 0;
  overflow: hidden;
  margin-bottom: 12px;
  .header {
    width: 100%;
    overflow: hidden;

    .img_header {
      float: left;
      .img {
        padding: 8px 14px 0 3px;
        float: left;
        img {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          overflow: hidden;
        }
      }
      .infomation {
        float: left;
        color: #898989;
        p {
          padding: 7px 0 4px 0;
          font-size: 14px;
          color: #000;
          .el-tag {
            margin-left: 10px;
          }
        }
        span {
          font-size: 12px;
          padding-right: 10px;
        }
      }
    }
    .el-dropdown {
      float: right;
      font-size: 20px;
      cursor: pointer;
    }
  }
  .main_are {
    float: right;
    width: 768px;
    margin-top: 20px;
    .txt {
      color: #2b2b2b;
      font-size: 16px;
      img {
        margin: 23px 0 18px;
        width: 339px;
        height: 247px;
      }
      p {
        margin-bottom: 25px;
        span {
          cursor: pointer;
          margin-right: 15px;
          font-size: 14px;
          color: #898989;
          // &:last-child{
          //     color:#2c84ff;
          // }
        }
      }
    }
    .pinglun {
      cursor: text;
      box-sizing: border-box;
      margin-top: 15px;

      input {
        outline: none;
        border: 0;
        width: 100%;
        height: 50px;
        text-indent: 2rem;
        line-height: 50px;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #d3d7e0;
        font-size: 16px;
      }
    }
    .el-button {
      float: right;
      margin-top: 10px;
      margin-right: 20px;
    }
  }
}
</style>